module.exports = __webpack_public_path__ + "static/media/pekka_johannes.2227984d.png";